import { render } from "./order_item.vue?vue&type=template&id=d28e0b8c"
import script from "./order_item.vue?vue&type=script&lang=js"
export * from "./order_item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__